export function convertMenhirToPyvarPipeTranslate(menhirTranslation) {
    const reg = /(\[[a-z]{2})(_)([A-Z]{2}\])/g;

    return menhirTranslation.replace(reg, '$1-$3');
}

export function converPyvarToMenhirPipeTranslate(pyvarTranslation) {
    const reg = /(\[[a-z]{2})(-)([A-Z]{2}\])/g;

    return pyvarTranslation.replace(reg, '$1_$3');
}

export function cleanSingleTranslation(pipeStr, defaultLang) {
    const reg = /(\[[a-z]{2})(-)([A-Z]{2}\])/g;
    const locale = pipeStr.match(reg);
    if (locale?.length === 1 && locale[0] === `[${defaultLang}]`) pipeStr = pipeStr.replace(reg, '');
    return pipeStr;
}

export function addDefaultLanguageCode(pipeStr, locale) {
    const reg = /(\[[a-z]{2})(-)([A-Z]{2}\])/g;
    if (!pipeStr.match(reg) && pipeStr?.length) pipeStr = `[${locale}]${pipeStr}`;
    return pipeStr;
}

export function getPipeTranslationByLocale(pipeStr, locale) {
    const found = pipeStr?.split(/\|?\[/g).find(str => str.slice(0, locale.length) === locale);
    if (!found) return '';
    const offset = locale.length + 1;
    return found?.slice(offset, found.length);
}
